module.exports = __webpack_public_path__ + "img/snyk-logo.0e7a97d5.png";